import { isReactNativeAppAuthContainer } from "native-sdk";

/**
 * DriveNative owns its AppAuth lifecycle, so its WebView must use AppAuth even
 * while the general Drive rollout remains disabled. Other containers continue
 * to use the release feature flag.
 */
export function shouldUseAppAuthIamLogin(featureFlagEnabled: boolean | undefined): boolean {
    return isReactNativeAppAuthContainer() || featureFlagEnabled === true;
}
